import { render, staticRenderFns } from "./ConfirmCampaignOfferComboTable.vue?vue&type=template&id=219204f7&scoped=true"
import script from "./ConfirmCampaignOfferComboTable.vue?vue&type=script&lang=js"
export * from "./ConfirmCampaignOfferComboTable.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCampaignOfferComboTable.vue?vue&type=style&index=0&id=219204f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219204f7",
  null
  
)

export default component.exports